import React from "react";

import styles from "./logbooks.module.scss";

export const WorkspaceContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.workspaceContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
